import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

const roles = ['Frontend Developer', 'Backend Developer', 'AI Engineer', 'Product Designer', 'Marketing', 'Internship', 'HR Intern', 'Marketing Head', 'Marketing Intern'];

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://api.masriq.tech').replace(/\/$/, '');

const Career = () => {
  const [showModal, setShowModal] = React.useState(false);
  // Form state
  const [form, setForm] = React.useState({
    name: '',
    email: '',
    phone: '',
    role: '',
    resume: null,
    agreed: false,
  });
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (name === 'resume') {
      setForm((prev) => ({ ...prev, resume: files[0] }));
    } else if (type === 'checkbox') {
      setForm((prev) => ({ ...prev, [name]: checked }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const formData = new FormData();
  formData.append('name', form.name);
  formData.append('email', form.email);
  formData.append('phone', form.phone);
  formData.append('role', form.role);
  formData.append('resume', form.resume);
  formData.append('agreed', form.agreed ? 'Yes' : 'No');

      const res = await fetch(`${API_BASE_URL}/api/career/apply`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        setMessage('Application submitted successfully!');
        setForm({ name: '', email: '', role: '', resume: null });
      } else {
        setMessage(data.error || 'Submission failed.');
      }
    } catch (err) {
      setMessage('Submission failed.');
    }
    setLoading(false);
  };

  return (
    <section id="careers" className="py-24 px-6 bg-[#0B0C1C] text-white">
      <h2 className="text-4xl sm:text-5xl font-bold text-center mb-12 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
        Careers at MASRIQ
      </h2>

      <motion.div
        className="max-w-4xl mx-auto bg-white/5 backdrop-blur-xl p-10 rounded-2xl shadow-glow space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <p className="text-center text-lg text-white/80 mb-4">
          We’re always looking for passionate creators. Apply now to be part of the future!
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label className="block mb-2 text-sm">Full Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="w-full p-3 rounded bg-[#12192a] text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
              required
            />
          </div>
          <div>
            <label className="block mb-2 text-sm">Email Address</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className="w-full p-3 rounded bg-[#12192a] text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
              required
            />
          </div>
          <div>
            <label className="block mb-2 text-sm">Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Your Phone Number"
              className="w-full p-3 rounded bg-[#12192a] text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
              required
              pattern="[0-9]{10,15}"
              title="Please enter a valid phone number"
            />
          </div>
          <div>
            <label className="block mb-2 text-sm">Applying For</label>
            <select
              name="role"
              value={form.role}
              onChange={handleChange}
              className="w-full p-3 rounded bg-[#12192a] text-white focus:outline-none focus:ring-2 focus:ring-purple-400"
              required
            >
              <option value="">Select a role</option>
              {roles.map((role, idx) => (
                <option key={idx} value={role}>{role}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-2 text-sm">Upload Resume</label>
            <input
              type="file"
              name="resume"
              accept=".pdf,.doc,.docx"
              onChange={handleChange}
              className="w-full file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:bg-cyan-500 file:text-white hover:file:bg-cyan-600"
              required
            />
          </div>
          <div className="flex items-center mb-4">
            <input
              type="checkbox"
              name="agreed"
              checked={form.agreed}
              onChange={handleChange}
              className="mr-2 accent-cyan-400"
              required
            />
            <span className="text-sm text-white/80">
              I agree to the
              <button
                type="button"
                className="text-cyan-400 underline mx-1 bg-transparent border-none cursor-pointer"
                onClick={() => setShowModal(true)}
              >
                Terms & Services, Privacy Policy
              </button>
            </span>
          </div>

          {/* Modal for Terms & Services and Privacy Policy */}
          {showModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
              <div className="bg-[#181A2A] rounded-2xl shadow-xl max-w-lg w-full p-8 relative overflow-y-auto max-h-[80vh]">
                <button
                  className="absolute top-4 right-4 text-white text-2xl font-bold hover:text-cyan-400"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                >
                  &times;
                </button>
                <h2 className="text-2xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent text-center">Terms & Services & Privacy Policy</h2>
                <div className="space-y-6 text-white/90 text-base">
                  <div>
                    <h3 className="font-semibold text-lg mb-2">Terms & Services</h3>
                    <ul className="list-disc pl-5 space-y-2">
                      <li><strong>Application Process:</strong> All information provided must be accurate and complete. Submission of an application does not guarantee employment or internship.</li>
                      <li><strong>Roles & Opportunities:</strong> Open positions are listed on our website and may change at any time. MASRIQ reserves the right to modify, withdraw, or fill any role without prior notice.</li>
                      <li><strong>Selection & Communication:</strong> Applications are reviewed by our team. Only shortlisted candidates will be contacted for further steps. MASRIQ may contact you via email or phone for interviews or additional information.</li>
                      <li><strong>Employment & Internship Terms:</strong> Offers are subject to successful completion of interviews and verification. Internships and employment are governed by separate agreements provided upon selection. MASRIQ expects professionalism, confidentiality, and adherence to company policies.</li>
                      <li><strong>Data Usage:</strong> Your application data is used solely for recruitment purposes. Resumes are stored securely and shared only with authorized team members.</li>
                      <li><strong>Withdrawal & Updates:</strong> You may withdraw your application at any time by contacting <a href="mailto:careers@masriq.tech" className="text-cyan-400 underline">careers@masriq.tech</a>. MASRIQ may update these terms; please review them periodically.</li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-2">Privacy Policy</h3>
                    <ul className="list-disc pl-5 space-y-2">
                      <li><strong>Information Collected:</strong> We collect your name, email, phone number, role applied for, resume, and agreement to terms.</li>
                      <li><strong>Use of Information:</strong> Data is used for recruitment, communication, and evaluation of your application. Only authorized MASRIQ team members have access to your information.</li>
                      <li><strong>Resume & Documents:</strong> Uploaded resumes are stored in secure cloud storage (Google Drive). Resume links are recorded in our internal Google Sheet for team review.</li>
                      <li><strong>Data Retention:</strong> Application data is retained for up to 12 months or as required by law. You may request deletion of your data by contacting <a href="mailto:careers@masriq.tech" className="text-cyan-400 underline">careers@masriq.tech</a>.</li>
                      <li><strong>Third Parties:</strong> We do not sell or share your data with third parties except for recruitment purposes within MASRIQ.</li>
                      <li><strong>Security:</strong> We use industry-standard security measures to protect your data.</li>
                      <li><strong>Updates:</strong> This policy may be updated; please check regularly for changes.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="text-center">
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-purple-500 to-cyan-400 rounded-full hover:scale-105 transition text-white font-semibold"
              disabled={loading || !form.agreed}
            >
              {loading ? 'Submitting...' : 'Submit Application'}
            </button>
          </div>
          {message && (
            <div className="text-center text-cyan-400 font-semibold mt-4">{message}</div>
          )}
          {/* Social Media Buttons after successful submission */}
          {message === 'Application submitted successfully!' && (
            <div className="flex flex-col items-center gap-4 mt-8">
              <a
                href="https://whatsapp.com/channel/0029VbBO1oB0wajphmdNXt29"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3 flex items-center justify-center gap-3 bg-gradient-to-r from-green-400 to-cyan-500 rounded-full hover:scale-105 transition text-white font-semibold text-center shadow-lg"
              >
                <FaWhatsapp size={22} /> Join WhatsApp Channel
              </a>
              <a
                href="https://www.instagram.com/masriqnext.tech/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3 flex items-center justify-center gap-3 bg-gradient-to-r from-pink-500 to-yellow-400 rounded-full hover:scale-105 transition text-white font-semibold text-center shadow-lg"
              >
                <FaInstagram size={22} /> Follow on Instagram
              </a>
              <a
                href="https://www.linkedin.com/company/masriqnxtech/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3 flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-purple-500 rounded-full hover:scale-105 transition text-white font-semibold text-center shadow-lg"
              >
                <FaLinkedin size={22} /> Connect on LinkedIn
              </a>
              <a
                href="https://www.facebook.com/masriqnxttech"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3 flex items-center justify-center gap-3 bg-gradient-to-r from-blue-500 to-blue-300 rounded-full hover:scale-105 transition text-white font-semibold text-center shadow-lg"
              >
                <FaFacebook size={22} /> Like us on Facebook
              </a>
            </div>
          )}
        </form>
      </motion.div>
    </section>
  );
};

export default Career;
